// /preview/invitation/dw001-amora/componentsMap.js

import Couple from "./components/Couple";
import Events from "./components/Events";
import Gallery from "./components/Gallery";
import Gifts from "./components/Gifts";
import Hero from "./components/Hero";
import Journey from "./components/Journey";
import OpenInvitation from "./components/OpenInvitation";
import Quote from "./components/Quote";
import RSVP from "./components/RSVP/RSVP";
import Thankyou from "./components/Thankyou";

export const componentsMap = {
  hero: Hero,
  couple: Couple,
  journey: Journey,
  events: Events,
  rsvp: RSVP,
  gallery: Gallery,
  gifts: Gifts,
  thankyou: Thankyou,
  quote: Quote,
  openinvitation: OpenInvitation,
};
